module.exports = __webpack_public_path__ + "static/img/add_order.238c6cd8.png";